const STORAGE_KEY = 'leadsListState';

export function saveLeadsState(state) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (e) {
    // sessionStorage not available
  }
}

export function loadLeadsState() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function clearLeadsState() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // sessionStorage not available
  }
}
